module.exports = __webpack_public_path__ + "img/index-cover-mobile.77d31143.png";